__webpack_require__.p = "/reports-dashboard-templates-old-essentials-banner/referrals-hub/";